import * as getters from './getters';
import actions from './actions';
import mutations from './mutations';

const state = () => ({
  guides: [],
  guideFetchDate: null,
  guideFetchLanguage: null,
  getGuides: {
    loading: false,
    error: null,
  },
  guideByGroup: {
    data: null,
    loading: false,
    error: null,
  },
});

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
